module.exports = __webpack_public_path__ + "static/img_2432-bb280c5d88f964667b0bca423de1ecb4.webp";